import { useRef, useCallback } from "react";

export const useChatScroll = () => {
  const conversationRef = useRef(null);

  const scrollToBottom = useCallback(() => {
    if (conversationRef.current) {
      conversationRef.current.scrollTop = conversationRef.current.scrollHeight;
    }
  }, []);

  const isNearBottom = useCallback(() => {
    if (!conversationRef.current) return true;
    const { scrollTop, scrollHeight, clientHeight } = conversationRef.current;
    return scrollHeight - scrollTop - clientHeight < 100;
  }, []);

  return {
    conversationRef,
    scrollToBottom,
    isNearBottom,
  };
};
